import env from 'env'
import { normalizeEatersValue } from 'app/utils/validation'

export const FLAG = '2026_09_lead_schedule_step'

const MIN_EATERS_FOR_SCHEDULE = 50

// Kept out of the component so config.js can gate the step without importing it.
export const usesScheduler = data =>
  !!data.occasion?.groups?.includes('b2b') &&
  normalizeEatersValue(data.eaters) >= MIN_EATERS_FOR_SCHEDULE

// Eligibility and the kill switch, without the flag: enrolment and the exposure
// event both ask this, and reading the arm there would be circular.
export const experimentApplies = data =>
  usesScheduler(data) && env.LEAD_SCHEDULE_EXPERIMENT_ENABLED === '1'

// Anything that isn't an arm we recognise means control — today's behaviour, so
// failing into it is always safe. One function so the steps and the success screen
// can never disagree about which arm the visitor is in.
export const scheduleArm = (data, experiments) => {
  if (!experimentApplies(data)) return 'control'

  const arm = experiments?.[FLAG]
  return arm === 'schedule_first' || arm === 'schedule_second' ? arm : 'control'
}
